import { Box, Container } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import ErrorBoundary from "../../components/ErrorBoundary";
import EventSectionTitle from "../../components/EventSectionTitle";
import EventSetupStepper from "../../components/EventSetupStepper";
import EventTabPanel from "../../components/EventTabPanel";
import Page from "../../components/Page";
import useEvent from "../../hooks/useEvent";
import useRegFields from "../../hooks/useRegFields";
import { TABS_LIST } from "./config";
import { valSchemaBrand, valSchemaInfo, valSchemaVis } from "./entries";

const EventSetup = () => {
  const { hash } = useLocation();
  const history = useHistory();
  // ...
  const tabHashs = TABS_LIST.map((t) => t.hash);
  const hashIdx = tabHashs.indexOf(hash);
  const tabHashIdx = hashIdx !== -1 ? hashIdx : 0;
  const { data } = useEvent();
  const { data: dataR } = useRegFields();
  // ...
  const [currTab, setCurrTab] = useState(tabHashIdx);
  const [valSteps, setValSteps] = useState([false, false, false, false]);

  //# Handle Navigation
  const setCurrTabHandler = (idx) => {
    const hash = tabHashs[idx] || tabHashs[0];
    history.push(`/event-setup${hash}`);
  };
  // ...
  const onBackHandler = () => {
    const ps = currTab - 1;
    if (ps < 0) setCurrTab(1);
    setCurrTab(ps);
  };

  //#Validate Steps
  const onValidate = async () => {
    let _vals = [false, false, false];
    let _data = { ...data, ...dataR };
    // ...
    try {
      await valSchemaInfo.validate(_data);
      _vals[0] = true;
    } catch (err) {
      _vals[0] = false;
    }
    try {
      await valSchemaBrand.validate(_data);
      _vals[1] = true;
    } catch (err) {
      _vals[1] = false;
    }
    try {
      await valSchemaVis.validate(_data);
      _vals[2] = true;
    } catch (err) {
      _vals[2] = false;
    }
    // # Review Step
    _vals[3] = _data?.published;
    // ...
    setValSteps(_vals);
  };
  // ...
  useEffect(() => {
    setCurrTab(tabHashIdx);
  }, [hashIdx, tabHashIdx]);
  // ...
  useEffect(() => {
    onValidate();
  }, [data, dataR]);
  // ...
  return (
    <Page title="Event Informations">
      <Container>
        <Box>
          <EventSectionTitle
            title="Event Informations"
            subTitle="Add the primary event details and publish your event"
            src="/static/setup/title/setup.svg"
          />

          <EventSetupStepper
            isFree={data?.isFree}
            valSteps={valSteps}
            // ...
            currTab={currTab}
            setCurrTab={(step) => {
              setCurrTabHandler(step);
            }}
            ITEMS={TABS_LIST}
          />

          {TABS_LIST.map((tab, idx) => (
            <EventTabPanel key={idx} value={idx} currTab={currTab}>
              {/* ZONE « ÉTAPE DE L'ASSISTANT ». Posée le 16/09/2026.

                  L'assistant est l'écran le plus lourd et le plus exposé du module :
                  c'est celui de la recette du 16/09, et les champs d'inscription qu'on
                  y saisit sont un blob JSON libre (c'est d'ailleurs ce module qui
                  alimente le `RegFieldsBoundary` d'`evey.next`). Une seule étape
                  fautive ne doit pas emporter les trois autres.

                  Le titre de section et le `EventSetupStepper` ci-dessus restent donc
                  debout : l'organisateur voit quelle étape a échoué, et peut passer aux
                  autres au lieu de tout reprendre.

                  `EventTabPanel` ne rend que l'onglet courant (`value === currTab`),
                  donc cette barrière n'entoure jamais qu'une étape à la fois.

                  `resetOn={currTab}` : changer d'étape désarme la barrière, sinon elle
                  resterait affichée sur une étape saine. Elle est posée DANS le panneau
                  pour que le désarmement suive l'onglet. */}
              <ErrorBoundary
                zone={`event-setup/${tab.hash.replace("#", "")}`}
                resetOn={currTab}
                title="This step couldn't be displayed"
                message="Something went wrong while rendering this part of the setup. The other steps are still available from the stepper above, and everything you had already saved is untouched. Try again — if it keeps failing, tell us which step you were on and what you last changed.">
                <tab.Node
                  idx={idx}
                  currTab={currTab}
                  valSteps={valSteps}
                  setCurrTab={setCurrTab}
                  onBackHandler={onBackHandler}
                  // ...
                  setCurrTabHandler={setCurrTabHandler}
                />
              </ErrorBoundary>
            </EventTabPanel>
          ))}
        </Box>
      </Container>
    </Page>
  );
};

export default EventSetup;
